<template>
  <ul class="l-sidebar-list">
    <li
      :class="[isCurrent ? 'is-current' : '']"
      class="l-sidebar-list__item l-sidebar-list__item--delivery"
    >
      <a :href="parentUrl">
        <div class="c-cell">
          <div class="c-icon u-wh28 c-icon--blue">
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <use :xlink:href="'/assets/img/sprite.svg#' + icon" />
            </svg>
          </div>
          <span class="l-sidebar__text">{{ title }}</span>
        </div>
      </a>
    </li>
    <li
      v-for="detail in details"
      :key="detail.title"
      :class="[detail.isCurrent ? 'is-current' : '']"
      class="l-sidebar-list__item l-sidebar-list__item--detail"
    >
      <a @click="itemClick(detail.url)">{{ detail.title }}</a>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    name: String,
    icon: String,
    title: String,
    isCurrent: Boolean,
    url: String,
    details: Array,
    onLinkClick: Function,
  },
  data: function () {
    return {
      className: "l-sidebar-list__item--" + this.name,
      parentUrl: this.url || '#' + this.name,
    };
  },
  mounted: function () {},
  methods: {
    itemClick: function (url) {
      this.onLinkClick(url);
    },
    imageClick: function () {},
  },
};
</script>
